export default __webpack_public_path__ + "static/media/ic_x_claim.381df9a5.svg";